<template>
  <Transition name="clothing-type-transition">
    <div class="clothing__option-list" :key="activeType">
      <ClothingOption
        :active-type="activeType"
        :clothing="clothing"
        v-for="clothing in clothingOptions"
        :key="clothing.id"
      />
    </div>
  </Transition>
</template>

<script>
import ClothingOption from '@/components/clothing/ClothingOption.vue'

export default {
  name: 'ClothingType',
  components: { ClothingOption },
  props: {
    activeType: {
      type: String,
      default: null,
    },
  },
  computed: {
    clothingOptions() {
      return Object.values(this.$store.state.clothing.all[this.activeType])
    },
  },
}
</script>
